import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useGroupConsumptionTableStyles = makeStyles({
  root: {
    overflowX: 'auto',
    // Prevent focus outline on header row from being clipped
    paddingTop: '2px',
  },
  shareBar: {
    display: 'inline-flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalS),
    width: '100%',
  },
  shareBarTrack: {
    height: '8px',
    ...shorthands.borderRadius(tokens.borderRadiusSmall),
    flexGrow: 1,
    backgroundColor: tokens.colorNeutralBackground3,
    position: 'relative',
    overflow: 'hidden',
  },
  shareBarFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    ...shorthands.borderRadius(tokens.borderRadiusSmall),
  },
  shareText: {
    fontSize: fontScale.caption,
    minWidth: '40px',
    textAlign: 'right',
  },
  utilGreen: { color: tokens.colorPaletteGreenForeground1, fontWeight: tokens.fontWeightSemibold },
  utilAmber: {
    color: tokens.colorPaletteMarigoldForeground2,
    fontWeight: tokens.fontWeightSemibold,
  },
  utilRed: { color: tokens.colorPaletteRedForeground1, fontWeight: tokens.fontWeightSemibold },
  rank: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
  },
});
